module.exports = __webpack_public_path__ + "img/goddess_happy.f9c83dfe.png";